import moment from 'moment'

UAExportUsersXLSXCtrl.$inject = ['$uibModalInstance', '$uibModal', 'users', 'domain', 'configuration', 'skipModal']

export default function UAExportUsersXLSXCtrl($uibModalInstance, $uibModal, users, domain, config, skipModal) {
  this.users = users
  this.domain = domain
  this.includeSubgroups = skipModal ? false : true // If skipping modal, set to false since no subgroups exist
  this.skipModal = skipModal
  
  this.exportUsers = () => {
    const xhr = new XMLHttpRequest()
    const url = config.root + 'user_info/account?'
    xhr.open('POST', url, true)
    xhr.responseType = 'arraybuffer'
    xhr.onload = () => {
      if (xhr.status === 200) {
        const filename = 
          moment(new Date()).format('YYYY-MM-DD') + ' Goalbook User List - ' + this.domain.name + '.xlsx'
        const type = xhr.getResponseHeader('Content-Type')
        
        // Download the file
        const blob = new Blob([xhr.response], { type: type })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
        
        $uibModalInstance.close()
      } else {
        // Error response must be converted from array buffer to get string
        const enc = new TextDecoder('utf-8')
        const errorMessage = enc.decode(xhr.response)
        
        // Show error modal
        const errorModal = $uibModal.open({
          backdrop: 'static',
          template: 
            '<div class="modal-header"><a class="close" ng-click="$close()">&times;</a><h2 class="modal-title">An error has occurred.</h2></div><div class="modal-body"><p>{{errorMessage}}</p></div><div class="modal-footer"><button class="btn btn-default" ng-click="$close()">OK</button></div>',
          controller: ['$scope', function($scope) {
            $scope.errorMessage = errorMessage
          }]
        })
        errorModal.result.then(
          () => $uibModalInstance.close(),
          () => $uibModalInstance.dismiss()
        )
      }
    }
    
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
    
    // Build the request data
    const userData = this.users
      .map(user => user.uuid)
      .join(',')
    
    const requestData = `users=${userData}&include_subgroups=${this.includeSubgroups}`
    xhr.send(requestData)
  }
  
  this.cancel = () => {
    $uibModalInstance.dismiss()
  }
  
  // If skipModal is true, automatically trigger export
  if (skipModal) {
    this.exportUsers()
  }
}
